import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import Button from 'flarum/common/components/Button';

app.initializers.add('tablou-editor-button', () => {
    extend(TextEditor.prototype, 'toolbarItems', function(items) {
        items.add('tablou', (
            <Button
                className="Button Button--icon Button--link"
                icon="fas fa-bolt"
                title="Inserare Tablou"
                onclick={() => {
                    const id = prompt('Introdu ID-ul proiectului:');
                    if (id) {
                        this.attrs.composer.editor.insertAtCursor(`[tablou]${id}[/tablou]`);
                    }
                }}
            >
                <span className="Button-label">Tablou</span>
            </Button>
        ));
    });
});
